let analytics;
import type { AnalyticsBrowser } from "@customerio/cdp-analytics-browser/";
import { atom } from "nanostores";
// export const $customerIo = atom<undefined | AnalyticsBrowser>(analytics);
export const $customerIo = atom<undefined | AnalyticsBrowser>(analytics);
